import React from "react";

export default function ClaimPassModal({ activeClaimPass, setActiveClaimPass }) {
  if (!activeClaimPass) return null;

  return (
    <div style={{
      position: "fixed",
      top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(26, 18, 8, 0.75)",
      backdropFilter: "blur(6px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      padding: "1rem",
      animation: "fadeIn 0.3s ease",
    }}
    onClick={() => setActiveClaimPass(null)}
    >
      <div style={{
        background: "var(--white)",
        border: "2px solid var(--gold)",
        borderRadius: "20px",
        maxWidth: "420px",
        width: "100%",
        boxShadow: "var(--shadow-lg), 0 0 30px rgba(200, 146, 42, 0.15)",
        overflow: "hidden",
        fontFamily: "'Outfit', sans-serif",
        position: "relative",
        animation: "scaleUp 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)",
      }}
      onClick={(e) => e.stopPropagation()}
      >
        <div style={{
          background: "var(--nav-bg)",
          padding: "1.25rem",
          textAlign: "center",
          borderBottom: "1px dashed var(--gold)",
          color: "var(--nav-text)",
          position: "relative",
        }}>
          <h4 style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: "1.5rem",
            color: "var(--gold)",
            margin: "0 0 4px 0",
            fontWeight: 700,
            letterSpacing: "0.02em",
          }}>
            Ebenezer Books
          </h4>
          <div style={{
            fontSize: "0.72rem",
            textTransform: "uppercase",
            letterSpacing: "0.15em",
            color: "var(--cream)",
            opacity: 0.8,
            fontWeight: 600,
          }}>
            Physical Reward Pass
          </div>

          <div style={{
            position: "absolute",
            left: "-10px",
            bottom: "-10px",
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            background: "rgba(26, 18, 8, 0.75)",
            zIndex: 10,
          }} />
          <div style={{
            position: "absolute",
            right: "-10px",
            bottom: "-10px",
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            background: "rgba(26, 18, 8, 0.75)",
            zIndex: 10,
          }} />
        </div>

        <div style={{ padding: "1.5rem", position: "relative" }}>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "-1.5rem -0.5rem 1.5rem",
            opacity: 0.25,
          }}>
            {[...Array(12)].map((_, i) => (
              <div key={i} style={{ width: "8px", height: "8px", borderRadius: "50%", background: "var(--ink)" }} />
            ))}
          </div>

          <div style={{
            display: "flex",
            gap: "1rem",
            background: "var(--white)",
            border: "1px solid var(--dust)",
            borderRadius: "12px",
            padding: "0.75rem",
            marginBottom: "1.25rem",
            alignItems: "center",
          }}>
            <div style={{
              width: "48px",
              height: "48px",
              borderRadius: "50%",
              background: "var(--cream)",
              border: "1.5px solid var(--gold)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "var(--gold)",
              fontSize: "1.3rem",
              flexShrink: 0,
            }}>
              🎁
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
              <h5 style={{
                fontFamily: "'Outfit', sans-serif",
                fontSize: "1rem",
                fontWeight: 700,
                color: "var(--ink)",
                margin: 0,
                lineHeight: 1.2,
              }}>
                {activeClaimPass.title}
              </h5>
              <span style={{ fontSize: "0.8rem", color: "var(--muted)" }}>
                {activeClaimPass.subtitle}
              </span>
            </div>
          </div>

          <div style={{
            background: "var(--cream)",
            border: "2px dashed var(--gold)",
            borderRadius: "10px",
            padding: "1rem 0.75rem",
            textAlign: "center",
            marginBottom: "1.25rem",
          }}>
            <div style={{ fontSize: "0.72rem", color: "var(--muted)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: "4px" }}>
              Voucher Claim Serial Code
            </div>
            <div style={{
              fontFamily: "'Courier New', Courier, monospace",
              fontSize: "1.45rem",
              fontWeight: 700,
              color: "var(--ink)",
              letterSpacing: "0.05em",
            }}>
              {activeClaimPass.code}
            </div>
          </div>

          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "4px",
            marginBottom: "1.25rem",
            opacity: 0.85,
          }}>
            <div style={{
              display: "flex",
              height: "36px",
              width: "180px",
              background: "#FFFFFF",
              border: "1px solid #E8E0D5",
              padding: "3px 8px",
              alignItems: "stretch",
              justifyContent: "space-between",
            }}>
              {[2, 1, 4, 2, 1, 3, 2, 4, 1, 3, 2, 1, 4, 2, 1, 3, 2, 4, 1].map((weight, i) => (
                <div key={i} style={{ width: `${weight}px`, background: i % 2 === 0 ? "#1A1208" : "transparent" }} />
              ))}
            </div>
            <span style={{ fontSize: "0.58rem", color: "var(--muted)", letterSpacing: "0.3em", fontFamily: "monospace" }}>
              {activeClaimPass.timestamp.replace(/[^0-9]/g, "").slice(0, 12)}
            </span>
          </div>

          <p style={{
            fontSize: "0.8rem",
            color: "var(--muted)",
            lineHeight: 1.5,
            textAlign: "center",
            margin: "0 0 1.25rem 0",
          }}>
            ✓ <strong>Present this screen at the bookstore front desk</strong>.<br/>
            ✓ Our clerk will verify your code and hand over your free physical copy reward!
          </p>

          <div style={{ fontSize: "0.68rem", color: "var(--muted)", textAlign: "center", fontStyle: "italic", opacity: 0.7 }}>
            Claimed on: {activeClaimPass.timestamp}
          </div>
        </div>

        <div style={{
          background: "var(--cream)",
          padding: "0.9rem 1.25rem",
          textAlign: "center",
          borderTop: "1px solid var(--dust)",
        }}>
          <button
            onClick={() => setActiveClaimPass(null)}
            style={{
              background: "var(--gold)",
              color: "var(--white)",
              border: "none",
              borderRadius: "8px",
              padding: "8px 24px",
              fontSize: "0.85rem",
              fontWeight: 600,
              cursor: "pointer",
              transition: "opacity 0.2s",
              boxShadow: "var(--shadow)",
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = 0.9}
            onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
          >
            Close Pass
          </button>
        </div>
      </div>
    </div>
  );
}
